import { formatString } from './strings';

const ELEMENT_NOT_FOUND = -1;

export const concatArrays = (array) => {
  return array?.reduce((a, b) => a.concat(b), []);
};

export const isObjInArray = (element, field, array) =>
  array?.findIndex((item) => item?.[field] === element?.[field]) !== ELEMENT_NOT_FOUND;

export const getCommonElements = (array1, array2) => {
  return array1.filter((value) => array2.includes(value));
};

/**
 * Map array of objects with name and value, to object with name
 * (removing the $wordToReplace from it) as key and url as value.
 */
export const mapArrayToNameValueObject = (fields = [], wordToReplace: string) => {
  return fields?.reduce(
    (map, field) => ({
      ...map,
      [formatString(field.name, wordToReplace)]: field.value,
    }),
    {}
  );
};

export const isEmptyArray = (array) => {
  if (!Array.isArray(array)) {
    return false;
  }

  if (!array || array?.length < 1) {
    return true;
  }

  return array?.every((item) => !item);
};

export const splitArray = (array, n: number) => {
  const [...arr] = array;

  const result = [];
  while (arr.length) {
    result.push(arr.splice(0, n));
  }

  return result;
};

export const uniqueArray = (array: unknown[], nested = false, key?: string) => {
  if (!nested) {
    return [...new Set(array)];
  }

  return array.filter(
    (obj, index, self) => index === self.findIndex((t) => t?.[key] === obj?.[key])
  );
};

export const uniqueArrayByKeys = (array, keys?: string[]) => {
  if (!keys.length || !array.length) {
    return [];
  }

  return array.reduce((list, item) => {
    const hasItem = list.find((listItem) => keys.every((key) => listItem[key] === item[key]));

    if (!hasItem) {
      list.push(item);
    }

    return list;
  }, []);
};

export const mapArray = (array: object[], key: string) => {
  if (!array || !key) {
    return {};
  }

  return array?.reduce((map, item) => {
    if (map?.[item?.[key]]) {
      const existingItems = map?.[item?.[key]];

      return {
        ...map,
        [item?.[key]]: [...existingItems, item],
      };
    }

    return {
      ...map,
      [item?.[key]]: [item],
    };
  }, {});
};

export const replaceKeyOfArray = (array, key, newKey) => {
  if (!array || !key || !newKey) {
    return [];
  }

  return array?.map(({ [key]: value, ...rest }) => ({
    [newKey]: value,
    ...rest,
  }));
};

export const convertArrayToObject = (array) =>
  array.reduce((accumulator, value) => ({ ...accumulator, [value]: true }), {});

export const moveInArray = (array: any[], fromIndex: number, toIndex: number): any[] => {
  const element = array[fromIndex];

  const newArray = [...array];
  newArray.splice(fromIndex, 1);
  newArray.splice(toIndex, 0, element);

  return newArray;
};

const stripHtmlTags = (html: string): string => html.replace(/<\/?[^>]+(>|$)/g, '');

export const mergeContentOfArrays = (array: any[], key = 'content', withoutHtml = true) =>
  array?.reduce((map, item) => {
    const content = withoutHtml ? stripHtmlTags(item?.[key]) : item?.[key];

    return `${map} ${content}`;
  }, '');
